import React from 'react';
import { QrScanCollectorModal } from '@/common/QrScan';

const BulkHvacScanFilterModal = ({ visible, onCancel, onApply }) => (
  <QrScanCollectorModal
    visible={visible}
    onCancel={onCancel}
    onApply={onApply}
    title="Scan to Filter HVAC Filters"
    description="Scan HVAC filter QR codes to build a filter. The table will show only the scanned filters."
    noun={{ singular: 'filter', plural: 'filters' }}
    manualPlaceholder="Type HVAC label (e.g. HF-123)"
    applyButtonText="Apply Filter"
  />
);

export default BulkHvacScanFilterModal;
